import expenseImport from './expenseImport';
import taskImport from './taskImport';
import fileImport from './fileImport';
import category from './category';
import taskCreate from './taskcreate';
import fileDownload from './filedownload';
import progressView from './progressview';
import progress from './progress';
import authorize from './authorize';
import categoryTask from './categoryTask';
import budget from './budget';
import taskapproval from './taskapproval';
import taskview from './taskview';
import taskactive from './taskactive';
import taskaudit from './taskaudit';
import taskauditmulti from './taskauditmulti';
import tasksummary from './tasksummary';
import taskend from './taskend';
import expense from './expense';
import analysis from './analysis';
import categoryItems from './categoryItems';
import items from './items';
import itemStat from './itemStat';
import itemResult  from './itemResult';
import taskDistribute from './taskdistribute';
import taskDistributeReply from './taskdistributereply';
import assignOrg from './assignorg';
import assignorgExcel from './assignorgExcel';
import authorizeExcel from './authorizeExcel';

export default {
    expenseImport,
    taskImport ,
    fileImport ,
    category,
    taskCreate,
    fileDownload,
    progressView,
    progress,
    authorize,
    categoryTask,
    budget,
    taskapproval,
    taskview,
    taskactive,
    taskaudit,
    taskauditmulti,
    tasksummary,
    taskend,
    itemStat,
    itemResult,
    expense,
    analysis,
    categoryItems,
    items,
    taskDistribute,
    taskDistributeReply,
    assignOrg,
    assignorgExcel,
    authorizeExcel
}